module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_2_1-c767962140c9d576c6e1d99efc1f306f.png";